import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { AdminTab } from '@/constants/adminTabs';
import { cn } from '@/lib/utils';

interface SidebarItemProps {
  tab: AdminTab;
  isActive: boolean;
  isExpanded: boolean;
  onClick: () => void;
}

const SidebarItem = ({ tab, isActive, isExpanded, onClick }: SidebarItemProps) => {
  const button = (
    <Button
      variant="ghost"
      onClick={onClick}
      className={cn(
        'w-full justify-start gap-3 px-3 py-1.5 h-auto transition-colors relative',
        isExpanded ? 'min-h-[40px]' : 'justify-center min-h-[36px]',
        isActive && 'bg-muted text-primary font-medium',
        !isActive && 'hover:bg-muted/50'
      )}
    >
      {/* Indicador de tab activo */}
      {isActive && (
        <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary rounded-r-full" />
      )}

      {/* Icono */}
      <div className={cn('h-5 w-5 shrink-0 flex items-center justify-center', isActive && 'text-primary')}>
        {tab.icon}
      </div>

      {/* Texto (solo cuando está expandido) */}
      {isExpanded && (
        <span className="text-sm font-medium truncate flex-1 min-w-0 text-left">
          {tab.label}
        </span>
      )}
    </Button>
  );

  // Mostrar tooltip cuando está colapsado
  if (!isExpanded) {
    return (
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>{button}</TooltipTrigger>
          <TooltipContent side="right">
            <p className="font-medium">{tab.label}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return button;
};

export default SidebarItem;
